import React from 'react';
import { Navigate, useNavigate } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// components
import { TextComponent } from 'baseComponents/TextComponent';
import { ButtonComponent } from 'baseComponents/ButtonComponent';

import { AuthPageWrapper } from 'components/layouts/AuthPageWrapper';
import { Flex, Spin } from 'antd';
import * as Yup from 'yup';
import { useSetUserPassword } from 'hooks/useSetPassword';
import { useSearchParams } from 'react-router-dom';
import {
  getAuthErrorMessage,
  parseErrorMessage,
  parseValidationErrorMessage,
} from 'helpers/get-auth-error-message';
import { PasswordInputComponent } from 'baseComponents/PasswordInputComponent';

type PasswordResetForm = {
  password: string;
};

export const passwordResetFormSchema = Yup.object().shape({
  password: Yup.string().required('Password is required'),
});

type PasswordResetScreenProps = {
  title: string;
};

export const ResetPasswordScreen = ({ title }: PasswordResetScreenProps) => {
  const [params] = useSearchParams();

  const { handleSubmit, control } = useForm<PasswordResetForm>({
    reValidateMode: 'onSubmit',
    resolver: yupResolver(passwordResetFormSchema),
  });
  const navigate = useNavigate();

  const {
    mutate: setPassword,
    isPending,
    isError,
    error,
  } = useSetUserPassword({
    onSuccess: () => {
      navigate('/');
    },
  });

  const token = params.get('token');

  if (!token) return <Navigate to='/' />;

  const onSubmit = async ({ password }: PasswordResetForm) => {
    setPassword({
      password,
      token,
    });
  };

  const errorMessage = () => {
    if (error) {
      if (getAuthErrorMessage(error) === 'validation schema error') {
        return parseValidationErrorMessage(error);
      }
      return parseErrorMessage(
        getAuthErrorMessage(error) || 'Something went wrong.'
      );
    }
    return (
      <TextComponent
        size='middle'
        styleType='danger'
        text={'Something went wrong.'}
      />
    );
  };

  return (
    <AuthPageWrapper
      title={<TextComponent size='title-size' text={title} inline />}
    >
      {isError && errorMessage()}
      <Spin spinning={isPending}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Flex vertical gap={20}>
            <Controller
              name='password'
              control={control}
              render={({ field, fieldState }) => (
                <PasswordInputComponent
                  label='Password'
                  // error={fieldState.error?.message}
                  {...field}
                />
              )}
            />
            <span />
            <ButtonComponent
              appereance='primary'
              size='large'
              label='Set password'
              uppercase
              fullWidth
              htmlType='submit'
            />
          </Flex>
        </form>
      </Spin>
    </AuthPageWrapper>
  );
};
